<template>
  <span :class="['env-tag', envClass, `env-variant-${variant}`]">
    <span class="env-dot"></span>
    {{ displayName }}
  </span>
</template>

<script>
export default {
  name: 'EnvironmentTag',
  props: {
    name: {
      type: String,
      default: ''
    },
    variant: {
      type: String,
      default: 'default',
      validator: (v) => ['default', 'login'].includes(v)
    }
  },
  computed: {
    envClass () {
      const n = this.name || ''
      if (n.includes('测试') || n.includes('test')) return 'env-test'
      if (n.includes('本地') || n.includes('local') || n.includes('dev')) return 'env-local'
      if (n.includes('预发') || n.includes('staging') || n.includes('uat')) return 'env-staging'
      if (n.includes('生产') || n.includes('正式') || n.includes('prod')) return 'env-prod'
      return 'env-default'
    },
    displayName () {
      // 生产环境显示简短名称，其他环境显示标签
      const n = this.name || ''
      if (n.includes('生产') || n.includes('正式') || n.includes('prod')) {
        // 生产环境可以返回空或简短标识，根据需求调�?        return n
      }
      return n
    }
  }
}
</script>

<style lang="scss" scoped>
.env-tag {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 2px 10px;
  border-radius: 12px;
  font-size: 13px;
  font-weight: 500;
  line-height: 1.5;
  border: 1px solid transparent;
  transition: all 0.2s ease;

  .env-dot {
    width: 7px;
    height: 7px;
    border-radius: 50%;
    display: inline-block;
  }
}

/* 测试环境 - 橙色 */
.env-test {
  background: #fff7e6;
  border-color: #ffd591;
  color: #d46b08;
  .env-dot { background: #fa8c16; }
}

/* 本地环境 - 蓝色 */
.env-local {
  background: #e6f7ff;
  border-color: #91d5ff;
  color: #096dd9;
  .env-dot { background: #1890ff; }
}

/* 预发环境 - 紫色 */
.env-staging {
  background: #f9f0ff;
  border-color: #d3adf7;
  color: #531dab;
  .env-dot { background: #722ed1; }
}

/* 生产环境 - 绿色 */
.env-prod {
  background: #f6ffed;
  border-color: #b7eb8f;
  color: #389e0d;
  .env-dot { background: #52c41a; }
}

/* 默认 */
.env-default {
  background: #f5f5f5;
  border-color: #d9d9d9;
  color: #595959;
  .env-dot { background: #8c8c8c; }
}

/* 登录页角标：紧凑、贴合卡�?*/
.env-variant-login {
  gap: 5px;
  padding: 5px 14px;
  border-radius: 0 0.5rem 0 10px;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.04em;
  border-top: none;
  border-right: none;

  .env-dot {
    width: 6px;
    height: 6px;
  }
}
</style>
